FileDroppableMixin = require 'mixins/file-droppable'

App.DishAltMediaComponent = Em.Component.extend [
  FileDroppableMixin
]...,
  classNames: [ 'dish-photo', 'dish-alt-media' ]
  classNameBindings: [ 'disabled:-disabled']

  dish: null
  fileInput: null

  dragStart: false
  isDeleteButtonShowed: false
  isLoading: false

  altMedia: (->
    dish = @get('dish')
    dish.get('alt_media').map (data, index) =>
      url: data.original
      isActive: false
  ).property('dish.alt_media.@each')

  activeMediaObserver: (->
    atLeastOneIsActive = @get('altMedia').some (media) => media.isActive
    @set('isDeleteButtonShowed', atLeastOneIsActive)
  ).observes('altMedia.@each.isActive')

  actions:
    openDialog: ->
      @get('fileInput')?.send('openDialog')
      false

    reorderMedia: () ->
      elements = Em.$('.media-item:not(.trash):not(.plus)')
      urls = elements.get().map (el) => 
        el.dataset.content
      data = 
        urls: urls
      @send('manipulatePhoto', data)

    uploadPhoto: (files) ->
      return if @get('isLoading')
      dish = @get('dish')
      altMedia = @get('altMedia')
      @set('isLoading', true)
      @sendAction('onChangeLoadingState', true)
      dish.uploadPhoto(files, {
        fileKey: 'alt_media'
      }).then => 
        dish.reload()
        @rerender()
      .finally =>
        @set('isLoading', false)
        @sendAction('onChangeLoadingState', false)
        @rerender()
    
    manipulatePhoto: (data) ->
      return if @get('isLoading')
      dish = @get('dish')
      @set('isLoading', true)
      @sendAction('onChangeLoadingState', true)
      body =  { 
        draft_dish: { 
          "#{if data.delete then 'delete_alt_media' else 'reorder_alt_media'}": data.urls 
        } 
      } 
      dish.nonRESTAction('PUT', '', body).then => 
        dish.reload()
      .finally =>
        @set('isLoading', false)
        @sendAction('onChangeLoadingState', false)
        @rerender()

    selectMedia: (media) ->
      return if @get('isLoading') 
      altMedia = @get('altMedia')
      currentMedia = altMedia.find (el) => el.url == media.url
      Ember.set(currentMedia, 'isActive', !currentMedia.isActive)
      false
    
    deleteMedia: ->
      return if @get('isLoading')
      deleteItems = @get('altMedia').filter((media) => media.isActive).map (media) => media.url
      data = 
        delete: true
        urls: deleteItems
      @send('manipulatePhoto', data)
